export class WebhookV1OnboardingPayload {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "type",
            "baseName": "type",
            "type": "WebhookV1OnboardingPayloadTypeEnum",
            "format": ""
        },
        {
            "name": "message",
            "baseName": "message",
            "type": "string",
            "format": ""
        },
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1OnboardingPayload.attributeTypeMap;
    }
    constructor() {
    }
}
export var WebhookV1OnboardingPayloadTypeEnum;
(function (WebhookV1OnboardingPayloadTypeEnum) {
    WebhookV1OnboardingPayloadTypeEnum["Onboarding"] = "onboarding";
})(WebhookV1OnboardingPayloadTypeEnum || (WebhookV1OnboardingPayloadTypeEnum = {}));
